import config from '../resources/config';

const getReadingTime = (text: string): number => {
    const wpm = config.timeline.words_per_minute;
    const words = text.trim().split(/\s+/).length;
    const time = Math.round((60 / wpm) * words) * 1000;
    return Math.max(time, 1000);
};

export const maxRecommendedReadingTime = 12000;

export default getReadingTime;
